export * from '@fhs/routing/src/routes/menu/(menu)/[slug]';
export { default } from '@fhs/routing/src/routes/menu/(menu)/[slug]';
